// Shared state between the logout buttons and the "Unsaved Changes" route guard.
//
// Logging out navigates to "/" (and the app shell swaps to the login screen).
// If the page being left had a UnsavedChangesGuard active, that navigation was
// intercepted and its "Unsaved Changes - Discard & Leave" dialog appeared on top
// of the login screen, right after the user had already chosen to log out.
//
// The logout confirmation dialog IS the user's decision to leave, so once it is
// confirmed the guard must stay out of the way (beginLogout). And so the user is
// still warned about losing work, the logout dialogs ask hasUnsavedChanges() and
// say so in their own message.

const activeGuards = new Set();
let loggingOutUntil = 0;

// Called by UnsavedChangesGuard whenever its `when` prop changes / it unmounts.
export const setUnsavedGuardActive = (id, active) => {
  if (active) activeGuards.add(id);
  else activeGuards.delete(id);
};

export const hasUnsavedChanges = () => activeGuards.size > 0;

// A short window (not a permanent flag) so a failed/aborted logout can never
// leave the guard disabled for the rest of the session.
export const beginLogout = () => {
  loggingOutUntil = Date.now() + 5000;
};

export const isLoggingOut = () => Date.now() < loggingOutUntil;

export const LOGOUT_MESSAGE = "You'll need to sign in again to continue.";
export const LOGOUT_UNSAVED_MESSAGE =
  "You have unsaved changes on this page. If you log out now they will be lost.";
